var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7C7 6.1715 6.3285 5.5 5.5 5.5C4.39 5.5 2.61 5.5 1.5 5.5C0.6715 5.5 0 6.1715 0 7V8.5C0 8.776 0.224 9 0.5 9H6.5C6.776 9 7 8.776 7 8.5V7ZM6 8V7C6 6.724 5.776 6.5 5.5 6.5C4.39 6.5 2.61 6.5 1.5 6.5C1.224 6.5 1 6.724 1 7V8H6ZM5.5 1.5C5.5 0.6715 4.8285 0 4 0C3.678 0 3.322 0 3 0C2.1715 0 1.5 0.6715 1.5 1.5V3C1.5 3.8285 2.1715 4.5 3 4.5H4C4.8285 4.5 5.5 3.8285 5.5 3V1.5ZM4.5 1.5C4.5 1.224 4.276 1 4 1C3.678 1 3.322 1 3 1C2.724 1 2.5 1.224 2.5 1.5V3C2.5 3.276 2.724 3.5 3 3.5H4C4.276 3.5 4.5 3.276 4.5 3V1.5Z",
    fill: "#3A3A3A",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.488d3f80c5259b6fba287d84ae02e262.svg";
export { ForwardRef as ReactComponent };